import { SEARCH, SHOW_NAV, NAV_CODE, FIX_HEADER } from '../mutation-types';

const state = {
    serarchVal: '',
    showNav: true,
    fixHeader: false,
    navCode: 'H'
};

const mutations = {
    [SEARCH] (state, payload) {
        state.serarchVal = payload.serarchVal;
    },
    [SHOW_NAV] (state, payload) {
        state.showNav = payload.showNav;
    },
    [NAV_CODE] (state, payload) {
        state.navCode = payload.navCode;
    },
    [FIX_HEADER] (state, payload) {
        state.fixHeader = payload.fixHeader;
    }
};

const actions = {
    updateSerarchValAction ({ commit }, serarchVal) {
        commit(SEARCH, serarchVal);
    },
    updateShowNavAction ({ commit }, showNav) {
        commit(SHOW_NAV, showNav);
    },
    updateNavCodeAction ({ commit }, navCode) {
        commit(NAV_CODE, navCode);
    }
};

const getters = {
    serarchVal (state) {
        return state.serarchVal;
    },
    showNavGetter (state) {
        return state.showNav;
    },
    navCodeGetter (state) {
        return state.navCode;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
